// ⚠️ MOCK — dados ilustrativos para validação com o cliente.
// Remover este arquivo quando as queries reais forem implementadas (ver PRD §14).
//
// Carona Solidária (CarpoolRecord + Bloc.capacity). As INTERFACES são o CONTRATO
// das futuras queries.

export interface CarpoolKpis {
    ridesInPeriod: number;          // caronas registradas no período
    currentOccupancy: number;       // COUNT(status='inside') agora
    totalCapacity: number;          // SUM(Bloc.capacity)
    occupancyRate: number;          // % (ex.: 28.3)
    uniqueVehicles: number;         // placas distintas no período
    manualRecordsPercent: number;   // % com isManualEntry|isManualExit (ex.: 6.4)
    carsSavedEstimate: number;      // carros a menos estimados (métrica de storytelling)
}

// Gráfico 1 — Ocupação por bloco (ColumnChart empilhado ABSOLUTO)
// available = Bloc.capacity − COUNT(status='inside') (PRD §46.5)
export interface BlocOccupancyRow {
    bloc: string;
    occupied: number;
    available: number;
}

// Gráfico 2 — Adesão ao programa (LineChart, entradas por semana)
export interface WeeklyAdhesionRow {
    week: string;      // 'DD/MM' (fim da semana)
    entries: number;
}

// Gráfico 3 — Picos de portaria (ColumnChart por faixa horária)
export interface GatePeakRow {
    hour: string;      // '06h' … '20h'
    entries: number;
    exits: number;
}

// Gráfico 4 — Qualidade da operação (ColumnChart, normais x correções manuais)
// base real: isManualEntry / isManualExit.
export interface OperationQualityRow {
    month: string;     // 'MM/YYYY'
    normal: number;
    manual: number;
}

// Gráfico 5 — Tempo médio de permanência por bloco (BarChart horizontal, horas)
// base real: exitAt − entryAt.
export interface AvgDwellByBlocRow {
    bloc: string;
    hours: number;
}

// ===========================================================================

export const MOCK_KPIS: CarpoolKpis = {
    ridesInPeriod: 487,
    currentOccupancy: 34,
    totalCapacity: 120,
    occupancyRate: 28.3,
    uniqueVehicles: 162,
    manualRecordsPercent: 6.4,
    carsSavedEstimate: 325,
};

// occupied soma 34 (= currentOccupancy); capacity soma 120 (= totalCapacity)
export const MOCK_BLOC_OCCUPANCY: BlocOccupancyRow[] = [
    {bloc: 'Bloco 07', occupied: 9, available: 11},
    {bloc: 'Almoxarifado', occupied: 4, available: 6},
    {bloc: 'Portaria Principal', occupied: 8, available: 22},
    {bloc: 'Doca 2', occupied: 5, available: 10},
    {bloc: 'Bloco 12', occupied: 6, available: 19},
    {bloc: 'Utilidades', occupied: 2, available: 18},
];

export const MOCK_WEEKLY_ADHESION: WeeklyAdhesionRow[] = [
    {week: '20/04', entries: 18},
    {week: '27/04', entries: 22},
    {week: '04/05', entries: 25},
    {week: '11/05', entries: 29},
    {week: '18/05', entries: 33},
    {week: '25/05', entries: 38},
    {week: '01/06', entries: 41},
    {week: '08/06', entries: 45},
    {week: '15/06', entries: 52},
    {week: '22/06', entries: 58},
    {week: '29/06', entries: 63},
    {week: '06/07', entries: 71},
];

export const MOCK_GATE_PEAKS: GatePeakRow[] = [
    {hour: '06h', entries: 12, exits: 2},
    {hour: '07h', entries: 48, exits: 4},
    {hour: '08h', entries: 63, exits: 6},
    {hour: '09h', entries: 29, exits: 5},
    {hour: '10h', entries: 14, exits: 7},
    {hour: '11h', entries: 9, exits: 9},
    {hour: '12h', entries: 11, exits: 22},
    {hour: '13h', entries: 18, exits: 15},
    {hour: '14h', entries: 10, exits: 8},
    {hour: '15h', entries: 8, exits: 10},
    {hour: '16h', entries: 7, exits: 14},
    {hour: '17h', entries: 9, exits: 41},
    {hour: '18h', entries: 6, exits: 55},
    {hour: '19h', entries: 4, exits: 33},
    {hour: '20h', entries: 2, exits: 12},
];

export const MOCK_OPERATION_QUALITY: OperationQualityRow[] = [
    {month: '02/2026', normal: 71, manual: 5},
    {month: '03/2026', normal: 68, manual: 4},
    {month: '04/2026', normal: 79, manual: 6},
    {month: '05/2026', normal: 74, manual: 3},
    {month: '06/2026', normal: 83, manual: 7},
    {month: '07/2026', normal: 80, manual: 6},
];

export const MOCK_AVG_DWELL_BY_BLOC: AvgDwellByBlocRow[] = [
    {bloc: 'Portaria Principal', hours: 9.1},
    {bloc: 'Utilidades', hours: 8.9},
    {bloc: 'Bloco 07', hours: 8.5},
    {bloc: 'Bloco 12', hours: 7.8},
    {bloc: 'Almoxarifado', hours: 6.2},
    {bloc: 'Doca 2', hours: 5.4},
];
